import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Rect from '@bubble-ui/primitive-rect';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotConstructionComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotConstruction',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M2.273 6.108C4.505 1.598 5.027 1.99 7.258 2c1.85.012 2.556-.017 3.746 0 .35.008.556.367.562.538v2.64c-1.22.023-1.99 1.34-1.96 1.83H7.011s-.28-.349-.369-.86c-.14-.914-.245-1.127-.602-1.235-1.063-.344-1.081.466-2.193 1.851-.566.718-1.124 1.075-1.57.875-.267-.106-.424-.68-.005-1.53Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M18.093 17.75s-.66.12-.82.8c0 0-.29 1.78-1 1.73-.8-.07-.6-.73-.45-3.57l2.27 1.04Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M21.793 19.78c-.75.63-2.13 2.16-2.73 1.64-.35-.3.58-1.74.58-1.74.56-.91-.61-1.35-.74-1.41l-2.86-1.25a.39.39 0 0 1-.2-.53l1.079-2.15h3.221l1.79 3.72c0-.01.58 1.11-.14 1.72Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "m17.453 16.68 1.16.48c.31.14.67 0 .8-.31l.1-.22c.13-.3-.01-.65-.3-.78l-1.16-.48c-.31-.14-.67 0-.8.31l-.1.22c-.13.3.01.65.3.78Z"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 2,
    height: 3.579,
    x: 13,
    y: 2,
    fill: "#D2A4FF",
    rx: 0.5
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M11.557 2.528H13v2.635h-1.443zM6.984 6.992h2.63l1.388 13.909A1 1 0 0 1 10.007 22H7.03a1 1 0 0 1-.998-1.068l.952-13.94ZM20.145 14.34h-3.22l-.47-11.298a1 1 0 0 1 1-1.042h1.937a1 1 0 0 1 1 1.022l-.247 11.318Z"
  }));
};
SpotConstructionComponent.displayName = 'SpotConstruction';
export var SpotConstruction = withProvisionalOverrideFromContext(SpotConstructionComponent);
//# sourceMappingURL=index.js.map